import GraphOverTime from "../Components/graphOverTime.js";

function Test() {
  return (
    <div>
      <GraphOverTime />
    </div>
  );
}

export default Test;